import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const StyledGridFooter = styled(Grid)`
  border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  margin: ${({ theme }) => `0 ${theme.x3spacePx}px`};
  padding: ${({ theme }) =>
    `${theme.x1spacePx}px 0 calc(${theme.x2spacePx}px + ${theme.safeAreaInsetBottom}) 0`};
`;
